















import { Component } from 'vue-property-decorator';
import Vue from 'vue';
import BpcContactTable from '@contacts/components/tables/contact-table/contact-table.vue';

@Component({
  name: 'bpc-club-team-and-groups',
  components: {
    'bpc-contact-table': BpcContactTable,
  },
})
export default class ClubTeamAndGroups extends Vue {
  /* Lifecycle hooks */
  // created() { }
  // mounted() {}
  // updated () { }
  // destroyed () { }
}
